import React, {useState, useEffect}from 'react';
import { Row, Col, Modal, Form, DropdownButton, Dropdown } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';
import ReactFlagsSelect from 'react-flags-select';
import Icons from '../../../Landing/icons.json'
import ImgIDFront from '../../../../Images/document-ID-front.png'
import InputFile from '../../../KycForm/components/inputFile'
import Backend from '../../../../Backend';
import Connection from '../../../../Calls';
import Countries from '../../../../Countries';
import '../index.css';

const BankInformation = ({BankList, getBankList, type, history, pending_upgrade, traductions}) => {

    useEffect(() => {
        
    }, [])
// ---------------- DATA ----------------

    const [ShowModalAddBank, setShowModalAddBank] = useState(false);

    const [DatosBancarios, setDatosBancarios] = useState({
        bank_name  :'', 
        bank_intermediary :'', 
        bank_address  :'', 
        billing_address  :'', 
        zip_code  :'', 
        state  :'', 
        city :'',
        bank_country :'',
        bank_id_account :'',
        bank_number_account :'',
        bank_currency :'USD',
        bank_aba :'',
        bank_swift :'',
        bank_spid :'',
        bank_clabe_account :'',
        EdoCuenta:'',
        uuid:''
    })

    const [Loading, setLoading] = useState(false)


    const updateDataBancarios = e =>{
        setDatosBancarios({
            ...DatosBancarios,
            [e.target.name]: e.target.value
        })
    }

    const updateDataBancariaDocs = (name,data) =>{
        setDatosBancarios({
            ...DatosBancarios,
            [name]: data
        })
    }
// ---------------- Methods ----------------

    const addNotification = (status,msg,type) => {
        store.addNotification({
          title: status,
          message: msg,
          type: type,
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 2500,
            onScreen: true
          }
        });
    }

    const getCountryName = (code) => {return Countries[code]}

    const getCountryCode = (name) => {
        if(name){
            let country = Object.entries(Countries).find((obj) => {
                if(obj[1] == name)
                    return obj
                else if(obj[0] == name)
                    return obj
            });
            
            if(country[0])
                return country[0]
        } 
    }
// ---------------- Calls ----------------
    const AddBank = () =>{
        setLoading(true)
        if(DatosBancarios.bank_country != ''  && DatosBancarios.bank_number_account != '' && DatosBancarios.bank_currency != '' 
        && DatosBancarios.bank_name != '' && DatosBancarios.state != '' && DatosBancarios.city != '' && DatosBancarios.zip_code != '' && DatosBancarios.bank_address != ''
        && DatosBancarios.billing_address != ''){
            if(DatosBancarios.bank_aba != '' || DatosBancarios.bank_swift != '' || DatosBancarios.bank_spid != '' || DatosBancarios.bank_clabe_account != ''){

                let promise_Edocuenta = new Promise ((resolve,reject) => upload_file(DatosBancarios.EdoCuenta, 'f_bank_bill', resolve)).then(value =>{
                    if(value){
                        updateDataBancariaDocs("EdoCuenta",{...DatosBancarios.EdoCuenta,correctUpload:true,uuid:value})
                        client_add_bank(value);
                    }else{
                        setLoading(false)
                    }
                })
            }else{
                addNotification("Error!",'You need to fill at least one of the following fields, ABA, SWIFT, SPID, CLABE',"danger");
                setLoading(false)
            }
        }else{
            addNotification("Error!",'Verify information, required fields cannot be empty',"danger");
            setLoading(false)

        }
        
    }

    const upload_file = (file, name, resolve) => {

        if (file != '' && file.img && name && !file.correctUpload) {
            
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
            navigator.geolocation.getCurrentPosition((success, error, options) => {
                latitude = success.coords.latitude;
                longitude = success.coords.longitude
            });

            result = latitude + longitude;

            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),file,name,response.payload.r01, response => {
            
                  if (response.status.code === "0"){
                    addNotification("Success!",response.payload.message,"success");
                    resolve(response.payload.uuid)
                  }else{
                    addNotification("Error!",response.status.description,"danger");
                    resolve(false)
                  }

                });
            });

        }else{
            if(file.correctUpload){
                resolve(DatosBancarios.EdoCuenta.uuid)
            }else{
                addNotification("Error!", "The necessary documents to upload are missing","danger");
                resolve(false)
            }
        }
    }

    const client_add_bank = (uuid) =>{

        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.client_add_bank(localStorage.getItem('email'), localStorage.getItem('token'),DatosBancarios, uuid, response.payload.r01, response => {
        
                if (response.status.code === "0"){
                    addNotification("Success!",'Bank added successfully',"success");
                    setShowModalAddBank(false)
                    setLoading(false)
                    setDatosBancarios({
                        bank_name  :'', 
                        bank_intermediary :'', 
                        bank_address  :'', 
                        billing_address  :'', 
                        zip_code  :'', 
                        state  :'', 
                        city :'',
                        bank_country :'',
                        bank_id_account :'',
                        bank_number_account :'',
                        bank_currency :'USD',
                        bank_aba :'',
                        bank_swift :'',
                        bank_spid :'',
                        bank_clabe_account :'',
                        EdoCuenta:'',
                        uuid:''
                    })

                    getBankList()


                }else{
                    addNotification("Error!",response.status.description,"danger");
                    setLoading(false)
                }

            });
        });
    
    }

    const client_remove_bank = uuid => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.client_remove_bank(localStorage.getItem('email'), localStorage.getItem('token'), uuid, response.payload.r01, response => {
                if (response.status.code === "0"){
                    addNotification("Success!",'Bank removed successfully',"success");                    
                    getBankList()
                }else{
                    addNotification("Error!",response.status.description,"danger");
                }

            });
        });
    }
    
// ---------------- Renders ----------------
    const renderBankList = () => {
        let toRender=[];

        // Lista de Bancos 
        if(BankList.length > 0){
            BankList.map((item, index) =>{
                toRender.push(
                    <>
                        <div className='Data'>
                            <p>{traductions.settings.bank.bk_status}: <span className={item.status}> {item.status}</span></p>
                            <Row>
                                <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_name}:</p>
                                    <p>{item.bank_name }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_country}:</p>
                                    <p>{item.bank_country }</p>
                                </Col>
                                <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_state}:</p>
                                    <p>{item.state }</p>
                                </Col>
                            </Row>
                            <Row>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_city}:</p>
                                    <p>{item.city }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_zip}:</p>
                                    <p>{item.zip_code }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_address}:</p>
                                    <p>{item.bank_address }</p>
                                </Col>
                            </Row>
                            <Row>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_Intermediary}:</p>
                                    <p>{item.bank_intermediary }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_BillingAddss}:</p>
                                    <p>{item.billing_address }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_accountNumber}:</p>
                                    <p>{item.bank_number_account }</p>
                                </Col>
                            </Row>
                            <Row>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_currency}:</p>
                                    <p>{item.bank_currency }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_Aba}:</p>
                                    <p>{item.bank_aba }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_swift}:</p>
                                    <p>{item.bank_swift }</p>
                                </Col>
                            </Row>
                            <Row>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_spid}:</p>
                                    <p>{item.bank_spid }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    <p>{traductions.settings.bank.bk_CLABE}:</p>
                                    <p>{item.bank_clabe_account }</p>
                                </Col>
                                 <Col lg={4} md={6} sm={12} >
                                    
                                </Col>
                            </Row>
                            <Row style={{justifyContent:'flex-end', padding:10}}>
                                    <button onClick={()=>{client_remove_bank(item.uuid)}} className='Btn_choosePlan'>
                                        {traductions.settings.bank.btn_remove}
                                    </button>
                            </Row>
                            {
                                (index+1 != BankList.length)
                                && <hr/>
                            }
                        </div>
                    </>
                )
            })
        }
        // Si hay menos de 2 bancos puedes añadir uno mas  BankList.length < 2 
        if(BankList.length < 2 ){
            toRender.push(
                <>
                <hr/>
                    <p className='addBank' onClick={()=>setShowModalAddBank(true)}>{traductions.settings.bank.btn_add} <span dangerouslySetInnerHTML={{__html:Icons['plus']}} className='modal-icon-container' /></p>
                    {renderModalAddBank()}
                <hr/>
                </>
            )
        }

        return toRender
    }

    const renderModalAddBank = () => {
        return(
            <Modal id="modal-add-bank" show={ShowModalAddBank} onHide={()=>setShowModalAddBank(false)} centered>
                <Modal.Body >
                    <p className='title-container-shadow' style={{marginBottom:16, fontSize:24}}>{traductions.settings.bank.title}</p>

                    <div>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_name} *</Form.Label>                  
                                    <Form.Control value={DatosBancarios.bank_name} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='bank_name' placeholder={traductions.settings.bank.bk_name} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_country} *</Form.Label>
                                    <center>
                                        <ReactFlagsSelect
                                            className="input-Country"
                                            searchable={true}
                                            searchPlaceholder="Search for a country"
                                            value={getCountryCode(DatosBancarios.Country)}
                                            onSelect={countryCode => updateDataBancariaDocs('bank_country',getCountryName(countryCode))}
                                        />
                                    </center>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_state} *</Form.Label>
                                    <Form.Control value={DatosBancarios.state} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='state' placeholder={traductions.settings.bank.bk_state} />                  
                                </Form.Group>                            
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_city} *</Form.Label>
                                    <Form.Control value={DatosBancarios.city} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='city' placeholder={traductions.settings.bank.bk_city} />                  
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_zip} *</Form.Label>
                                    <Form.Control value={DatosBancarios.zip_code} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='zip_code' placeholder={traductions.settings.bank.bk_zip} />                  
                                </Form.Group>                            
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_address} *</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_address} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='bank_address' placeholder={traductions.settings.bank.bk_address} />                  
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_Intermediary}  ({traductions.settings.bank.L_applicable})</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_intermediary} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='bank_intermediary' placeholder={traductions.settings.bank.bk_Intermediary} />                  
                                </Form.Group>                            
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_BillingAddss} *</Form.Label>
                                    <Form.Control value={DatosBancarios.billing_address} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='billing_address' placeholder={traductions.settings.bank.bk_BillingAddss}/>                  
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_accountNumber} *</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_number_account} onChange={updateDataBancarios} className="input-Formulario" type="text"  name='bank_number_account' placeholder={traductions.settings.bank.bk_accountNumber} />    
                                </Form.Group>
                            </Col>
                            <Col className='virtual_exchange_dropdown' xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_currency} *</Form.Label>
                                    <DropdownButton className="" title={DatosBancarios.bank_currency} style={{marginBottom:10}}>
                                        <Dropdown.Item onClick={()=>updateDataBancariaDocs('bank_currency', 'MXN')} as="button">MXN</Dropdown.Item>
                                        <Dropdown.Item onClick={()=>updateDataBancariaDocs('bank_currency', 'USD')} as="button">USD</Dropdown.Item>
                                    </DropdownButton>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">ABA ({traductions.settings.bank.L_applicable})</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_aba} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='bank_aba' placeholder="ABA" />                  
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">SWIFT ({traductions.settings.bank.L_applicable})</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_swift} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='bank_swift' placeholder="SWIFT" />                  
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">SPID ({traductions.settings.bank.L_applicable})</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_spid} onChange={updateDataBancarios} className="input-Formulario" type="text"  name='bank_spid' placeholder="SPID" />    
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc">{traductions.settings.bank.bk_CLABE} ({traductions.settings.bank.L_applicable})</Form.Label>
                                    <Form.Control value={DatosBancarios.bank_clabe_account} onChange={updateDataBancarios}  className="input-Formulario" type="text" name='bank_clabe_account' placeholder="CLABE" />                  
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={7}>
                                <Form.Group>
                                    <Form.Label className="label-blue-kyc" style={{height:50}}>{traductions.settings.bank.bk_statement} *</Form.Label>
                                    <InputFile name={'f_bank_bill'} label={traductions.settings.bank.bk_statement} image={ImgIDFront} setImage={e => updateDataBancariaDocs('EdoCuenta', e)}/>
                                </Form.Group>
                            </Col>
                        </Row>  
                      </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="upload-file-btn" onClick={()=>{AddBank()}} disabled={Loading}> 
                        {
                            (Loading)
                            ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                            : traductions.settings.bank.btn_save
                        }
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }

    return ( 
        <>
            <div>
                <p className='title-container-shadow' style={{marginBottom:16}}>{traductions.settings.bank.title}</p>
                {
                    (type != 'free' || pending_upgrade == 'True')
                    ?renderBankList()
                    :<div className='incompleteRecord'>
                        <p >{traductions.General.registerResponse.unregistered1}</p>
                        <p>{traductions.General.registerResponse.unregistered2} <span className='link' onClick={()=>history.push("/kyc") }>{traductions.General.registerResponse.click}</span></p>
                    </div>
                }
            </div>
        </>
     );
}
 
export default BankInformation;